module.exports = __webpack_public_path__ + "img/tv-active-icon.b3d63d82.svg";